module.exports = __webpack_public_path__ + "img/info.9d24f29f.svg";